/**
 * Cleanup plugin to remove old cookies set with an explicit `domain=...`
 * attribute from a previous config. The current code uses host-only cookies
 * via useCookie, so those are left untouched — overwriting them here would
 * wipe the freshly-written value on every page load.
 *
 * lastVisitedLocation never belonged on COOKIES_DOMAIN — that is the auth-sharing
 * mechanism for websale.cinestar.cz (composables/useAuthStorage.js). It was swept in by
 * the pre-CIN-611 useClientCookie, which applied the domain to everything written
 * through it, so this is migration debris with an end date:
 *
 * - stage/prod wrote domain-scoped `cinestar.cz` copies with a fixed 1-year maxAge until
 *   the host-only rewrite (a89f154, 2025-12-10) -> the last of them expire around 2026-12.
 * - testing/preprod `digital.cz` copies existed only from the same-day add/remove of
 *   COOKIES_DOMAIN on 2024-05-01 -> expired around 2025-05.
 *
 * Once the 2026-12 window has passed this plugin can be deleted outright.
 */
import { COOKIES_NAMES } from "~/utils/constants.js";

export default defineNuxtPlugin(() => {
  if (import.meta.server) return;

  const config = useRuntimeConfig();
  const cookieDomain = config.public.COOKIES_DOMAIN;
  if (!cookieDomain) return;

  const cookiesToClean = [COOKIES_NAMES.lastVisitedLocation];
  const pastDate = "Thu, 01 Jan 1970 00:00:00 GMT";

  cookiesToClean.forEach((cookieName) => {
    // Delete cookie with leading-dot domain (e.g., .cinestar.cz)
    document.cookie = `${cookieName}=; path=/; max-age=0; domain=.${cookieDomain}`;
    document.cookie = `${cookieName}=; path=/; expires=${pastDate}; domain=.${cookieDomain}`;

    // Delete cookie with plain domain (no leading dot)
    document.cookie = `${cookieName}=; path=/; max-age=0; domain=${cookieDomain}`;
    document.cookie = `${cookieName}=; path=/; expires=${pastDate}; domain=${cookieDomain}`;
  });
});
